import React, { useEffect, useState } from "react";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { CustomerPaymentColumns } from "../../../assets/Columns/CustomerPaymentColumns";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchCustomerPayments } from "../../../store/Slices/CustomerPaymentSlice";
import Header from "../../../components/Header/Header";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteCustomerPaymentApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import EditPaymentModal from "../../../components/Modals/EditPaymentModal";

const CustomerPayments = () => {
  const { id } = useParams();
  const [SearchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");
  const [Loading, setLoading] = useState(false);

  const CustomerPayments = useSelector((state) => state.CustomerPayments);

  useEffect(() => {
    dispatch(fetchCustomerPayments(id));
  }, []);

  return (
    <div className="w-full flex flex-col px-4 pt-2 pb-8 gap-y-8">
      <Header
        title="Customer-Payments"
        desc="Manage your payments efficiently"
      />
      {CustomerPayments.data && (
        <SearchableTable
          setOpenEditModal={setOpenEditModal}
          setOpenDeleteModal={setOpenDeleteModal}
          setSelected={setSelected}
          SearchPlaceholder={"Search Invoice #..."}
          SearchText={SearchText}
          setSearchText={setSearchText}
          CurrentData={CustomerPayments.data}
          Columns={CustomerPaymentColumns}
        />
      )}

      {OpenEditModal && Selected && (
        <EditPaymentModal
          Open={OpenEditModal}
          setOpen={setOpenEditModal}
          paymentDetails={Selected}
          type="Customer"
          onSuccess={() => dispatch(fetchCustomerPayments(id))}
        />
      )}

      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteCustomerPaymentApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Customer Payment delete successfully");
                dispatch(fetchCustomerPayments(id));
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              console.log(err);
            }
            setLoading(false);
          }}
        />
      )}
    </div>
  );
};

export default CustomerPayments;
